export default __webpack_public_path__ + "static/media/cyclops_2.f43fce1d.svg";